// What the Submissions dashboard shows when, kept apart from the page so the rules can be tested.

// The breakdowns that say little across every vertical: the page shows them only once a vertical is
// chosen. (Submissions by collection source is not one: it is a global question.)
export const SUBMISSIONS_DASHBOARD_DETAIL_BLOCKS: ReadonlySet<string> = new Set([
  'by_classification',
  'classifications',
  'classification_by_month',
  'by_language',
  'by_type'
]);

// The blocks that can run to a great many rows. They fold to a nominal height with a Show more button,
// so the dashboard keeps one shape however many classifications or analysts there are.
export const SUBMISSIONS_DASHBOARD_COLLAPSIBLE_BLOCKS: ReadonlySet<string> = new Set([
  'by_classification',
  'classifications',
  'classification_by_month',
  'by_analyst'
]);
